import React from 'react'
import { Project } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import styles from './ProjectCardBadges.module.scss'
import WarningBadge from './WarningBadge/WarningBadge'

interface PropsType {
  project: Project
  isOutOfStock: boolean
  saleOfferContent: React.ReactNode
}

const ProjectCardBadges: React.FC<PropsType> = (props: PropsType) => {
  const { project, isOutOfStock, saleOfferContent } = props
  const { t } = useTranslation()
  const inactiveTagIsVisible = !saleOfferContent && !project?.is_active

  return (
    <div className={styles.container}>
      {/* Out Of Stock */}
      {(isOutOfStock && !project?.is_free_donation) ? <WarningBadge label={t('Projects.OutOfStock')} /> : <div/>}

      {/* Inactvive Label */}
      {inactiveTagIsVisible && <WarningBadge label={t('Projects.Inactive')} isOutOfStock={false} /> }
    </div>
  )
}

export default ProjectCardBadges
